export * from './loader.component';

import { LoaderComponent } from './loader.component';

export const UI_LOADER = [LoaderComponent] as const;
